<template>
	<o-card
		v-bind="{ title }"
		class="card--settings">
		<template #header>
			<o-icon v-bind="{ fontIcon }"/>
		</template>

		<slot/>
	</o-card>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedSettingCardEmits, SharedSettingCardProps } from './SharedSettingCardSetup';
import SharedSettingCardSetup from './SharedSettingCardSetup';
const emits = defineEmits<SharedSettingCardEmits>() as SharedSettingCardEmits;
const props = withDefaults(defineProps<SharedSettingCardProps>(), SharedSettingCardSetup.defaultProps);
const setup = new SharedSettingCardSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
:deep(.orion-card) {
	&__header {
		.card--settings & {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 1.5rem;
			background: var(--grey-lighter);
		}

		.orion-icon {
			margin-top: 1.5rem;
			font-size: 2.5rem;
			color: var(--grey);
		}
	}
}
</style>
